export default "__VITE_ASSET__89b1c36a__"